import { render, staticRenderFns } from "./highlights-omn.vue?vue&type=template&id=5d29fa4b&scoped=true&"
import script from "./highlights-omn.vue?vue&type=script&lang=js&"
export * from "./highlights-omn.vue?vue&type=script&lang=js&"
import style0 from "./highlights-omn.vue?vue&type=style&index=0&id=5d29fa4b&scoped=true&lang=css&"
import style1 from "./highlights-omn.vue?vue&type=style&index=1&id=5d29fa4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29fa4b",
  null
  
)

export default component.exports